import type { JSX } from 'react'

import { DetailsPrimaryButton } from 'atoms/Button/Templates'
import { Link } from 'atoms/Link'
import {
  Banner,
  BannerAlignItems,
  BannerDescription,
  BannerDescriptionRowGap,
  BannerJustifyContent,
  BannerOverlayDirection,
} from 'blocks/Banner'
import { ButtonGroup } from 'blocks/ButtonGroup'
import { TextBlockBannerHeadlineExtra10 } from 'blocks/TextBlock/Templates/Banners/TextBlockBannerHeadlineExtra10'
import {
  BANNER_ASPECT_RATIO,
  BANNER_DESCRIPTION_WIDTH,
  BANNER_PADDINGS,
  BANNER_WIDTH,
} from 'vars/index'
import { BANNER_BUTTON_HEIGHT } from './lib'

export interface ICategoryBannerCardTemplateProps {
  width?: BANNER_WIDTH
  aspectRatio?: BANNER_ASPECT_RATIO
  justifyContent?: BannerJustifyContent
  alignItems?: BannerAlignItems
  paddings?: BANNER_PADDINGS
  overlayDirection?: BannerOverlayDirection
  overlayWidth?: number
  isCoverFallbackImage?: boolean
  overlayEnabled?: boolean
  descriptionWidth?: BANNER_DESCRIPTION_WIDTH
  rowGap?: BannerDescriptionRowGap
  title?: string
  locked?: boolean
  posterUrl?: string
  posterMobileUrl?: string
  horizontalCovers?: Record<string, string>
  verticalCovers?: Record<string, string>
  playTitle?: string
  showHowToWatchButton?: boolean | null
  howToWatchTitle?: string
  detailsLink?: string
  detailsTitle?: string
}

export const CategoryBannerCardTemplate = ({
  width = BANNER_WIDTH.SIZE_100,
  aspectRatio = BANNER_ASPECT_RATIO.SIZE_10,
  justifyContent = BannerJustifyContent.Flex_end,
  alignItems = BannerAlignItems.Start,
  paddings = BANNER_PADDINGS.SIZE_40,
  overlayDirection = BannerOverlayDirection.OVERLAY_HORIZONTAL,
  overlayWidth = 100,
  isCoverFallbackImage = true,
  overlayEnabled = true,
  descriptionWidth = BANNER_DESCRIPTION_WIDTH.SIZE_10,
  rowGap = BannerDescriptionRowGap.INDENT_60,
  title = '',
  locked = false,
  posterUrl = '',
  posterMobileUrl = '',
  horizontalCovers = undefined,
  verticalCovers = undefined,
  detailsLink = '',
  detailsTitle = '',
}: ICategoryBannerCardTemplateProps): JSX.Element => {
  return (
    <Banner
      width={width}
      aspectRatio={aspectRatio}
      justifyContent={justifyContent}
      alignItems={alignItems}
      paddings={paddings}
      overlayDirection={overlayDirection}
      overlayWidth={overlayWidth}
      title={title}
      locked={locked}
      isCoverFallbackImage={isCoverFallbackImage}
      overlayEnabled={overlayEnabled}
      posterUrl={posterUrl}
      posterMobileUrl={posterMobileUrl}
      horizontalCovers={horizontalCovers}
      verticalCovers={verticalCovers}
    >
      <BannerDescription width={descriptionWidth} rowGap={rowGap}>
        <TextBlockBannerHeadlineExtra10 title={title} />
        <ButtonGroup maxHeight={BANNER_BUTTON_HEIGHT.NORMAL}>
          <Link href={detailsLink}>
            <DetailsPrimaryButton title={detailsTitle} />
          </Link>
        </ButtonGroup>
      </BannerDescription>
    </Banner>
  )
}
